<div class="mr-6 h-fit max-h-[256px] gap-1 rounded-2xl border border-text-white p-3">
  <div class="flex items-center justify-between">
    <div class="flex w-fit items-center gap-[2px]">
      <svg-icon key="px-24-tick" class="text-secondary-green" />
      <span class="typo-h5-light text-text-tertiary">
        {{ 'charting_add_treatment_selected_label' | translate: { input1: addedTreatments().length } }}
      </span>
    </div>
    @if (extraCardNumber() > 0) {
      <button class="btn-text" (click)="toggleTrayExpanded()">
        <svg-icon [key]="isTrayExpanded() ? 'px-24-reduce' : 'px-24-expand'"></svg-icon>
      </button>
    }
  </div>

  <div
    #cardsContainer
    class="flex flex-wrap gap-2 overflow-scroll"
    [ngClass]="{ 'max-h-[216px]': isTrayExpanded(), 'max-h-[70px]': !isTrayExpanded() }"
  >
    @for (treatment of treatmentsToShow(); track treatment.dentalCode; let i = $index) {
      <lib-treatment-tray-card
        [treatment]="treatment"
        (treatmentRemoved)="onRemoveTreatment(i)"
        (treatmentUpdated)="onUpdateTreatment(i, $event)"
        (requiredInputEditRequested)="onOpenTeethSelector(i, treatment)"
        (surfaceEditRequested)="onOpenSurfaceSelector(i, treatment, $event)"
      />
    }
    @if (extraCardNumber() > 0 && !isTrayExpanded()) {
      <button #showMoreButton class="btn-text" (click)="toggleTrayExpanded()">
        {{ 'charting_add_treatment_more_label' | translate: { input1: extraCardNumber() } }}
      </button>
    }
  </div>
</div>
